import { createContext } from 'react';
import type { User } from './types';
import type { LogoutNavigationPurgeProof } from './logoutBoundary';

export interface AuthContextValue {
  user: User | null;
  role?: string | null;
  loading: boolean;
  bootstrapResolved: boolean;
  authEpoch: number;
  setUser: (u: User | null) => void;
  clearAuth: (proof?: LogoutNavigationPurgeProof) => void;
  refreshAuth: (opts?: { force?: boolean }) => Promise<User | null>;
  updatePersonalProfile: (profile: { id: number; full_name: string }) => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
